import React from 'react'
import { StateType } from '../state/state'
import { inject, observer } from 'mobx-react'
import { ReactComponent as CloseIcon } from '../../../assets/cross.svg'
import { CountryMultiSelect } from './CountryMultiSelect'
import { RegionsButtons } from './RegionsButtons'
import { DataTypeToggles } from './DataTypeToggles'

interface Props {
  className?: string
  state?: StateType
}

export const Modal: React.FC<Props> = inject('state')(
  observer(({ className = '', state }) => {
    const {
      isMobileModalOpened,
      setIsMobileModalOpened,
      resetModalFilters,
      debug,
    } = state.ScatterplotState

    const originalBodyOverflowYRef = React.useRef<string>()
    const originalHtmlOverflowYRef = React.useRef<string>()
    React.useEffect(() => {
      const body = document.body
      const html = document.body.parentElement
      if (isMobileModalOpened) {
        originalBodyOverflowYRef.current = window.getComputedStyle(body).overflowY
        originalHtmlOverflowYRef.current = window.getComputedStyle(body).overflowY
        body.style.overflowY = 'hidden'
        html.style.overflowY = 'hidden'
      } else {
        body.style.overflowY = originalBodyOverflowYRef.current
        html.style.overflowY = originalHtmlOverflowYRef.current
      }

      return () => {
        // unnecessary, but to be sure
        const body = document.body
        const html = document.body.parentElement
        body.style.overflowY = originalBodyOverflowYRef.current
        html.style.overflowY = originalHtmlOverflowYRef.current
      }
    }, [isMobileModalOpened])

    return (
      isMobileModalOpened && (
        <div className={`-modal fixed top-0 left-0 z-2 vw-100 vh-100 bg-gray pa2 ${className}`}>
          <div
            className="-modal-window bg-white w-100 br2 flex flex-column z-5"
            style={{ marginTop: 56, height: 'calc(100% - 56px)' }} // avoid header in prod
          >
            <div className={`flex flex-row justify-between pa3 h3 ${debug ? 'ba' : ''}`}>
              <div className="f6 fw6 black flex flex-center">MORE FILTERS</div>
              <CloseIcon
                className="w2 pv1 black pointer"
                onClick={() => setIsMobileModalOpened(false)}
              />
            </div>

            <div className={`overflow-y-auto ph3 mb3 flex flex-column ${debug ? 'ba' : ''}`}>
              <Container debug={debug}>
                <CountryMultiSelect className="" />
              </Container>

              <Container className="" debug={debug}>
                <RegionsButtons className="" />
              </Container>

              <Container className="" debug={debug}>
                <DataTypeToggles className="" />
              </Container>

              <Container className="" debug={debug}>
                <div className="flex justify-between">
                  <Button
                    className="bg-transparent gray80"
                    label="Reset"
                    onClick={() => {
                      resetModalFilters()
                      setIsMobileModalOpened(false)
                    }}
                  />
                  <Button
                    className="bg-blue500 white"
                    label="Confirm"
                    onClick={() => {
                      setIsMobileModalOpened(false)
                    }}
                  />
                </div>
              </Container>
            </div>
          </div>
        </div>
      )
    )
  })
)

interface ButtonProps {
  className?: string
  label: string
  onClick: () => void
}

const Button: React.FC<ButtonProps> = ({ className = '', label, onClick }) => {
  return (
    <div className={`-button ph4 pv3 ${className}`} style={{ borderRadius: 100 }} onClick={onClick}>
      {label}
    </div>
  )
}

interface ContainerProps {
  className?: string
  debug: boolean
  style?: Object
  children?: React.ReactNode
}

const Container: React.FC<ContainerProps> = ({ className = '', style = {}, debug, children }) => {
  return (
    <div
      className={`w-100 pointer ${debug ? 'ba' : ''} ${className}`}
      style={{ marginBottom: '1.5rem', ...style }}
    >
      {children}
    </div>
  )
}
